export * from './static';
export { BeneficiosStamp } from './beneficios-stamp';
export { BeneficiosStandard, BeneficiosStandard as Login } from './beneficios-standard';
//# sourceMappingURL=index.js.map